/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {

    init: function() {
      // GET FILTERS AND BUILD NEW URL THEN REFRESH
      $( '#resource_topic-select, #resource_brand-select' ).on( 'change', function() {
        const clearnUrl = document.location.href.replace( /\?.*/, '' );
        let brandQuery = '';
        let topicQuery = '';

        if ( $( '#resource_brand-select' ).val() !== 'default' ) {
          brandQuery = 'brand=' + $( '#resource_brand-select' ).val();
        }

        if ( $( '#resource_topic-select' ).val() !== 'default' ) {
          topicQuery = 'topic=' + $( '#resource_topic-select' ).val();
        }
        const built = clearnUrl + '?' + brandQuery + '&' + topicQuery;
        window.location = built;
      } );

      // clear filter
      $( '#resource-filter_clear' ).on( 'click', function() {
        const formatedUrl = document.location.href.replace( /\?.*/, '' );
        window.location = formatedUrl;
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'resource', COMPONENT );
} )( app );
